export const SET_USER = 'setUser';
export const SET_USER_SESSION = 'setUserSession';
export const CLEAR_USER = 'clearUser';
